export default __webpack_public_path__ + "static/media/NewYorkCityandWestchesterCounty_Hz_White.0d5329ae.png";